export default "__VITE_ASSET__63723c40__"